import axios from "axios";
import { getToken } from "../auth/authService";

function authHeaders() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const searchCanonicalLogs = (params) =>
  axios
    .get("/dashboard/canonical", { params, headers: authHeaders() })
    .then((r) => r.data);

export const getCanonicalJson = (id) =>
  axios
    .get("/dashboard/canonical/json", {
      params: { id },
      headers: authHeaders(),
    })
    .then((r) => r.data);
